import { Link } from "react-router-dom";
import NoImg from "@/assets/images/svg/no_data_found.svg";
import ConsentManager from "@/modules/frontend/components/ConsentManager";

function NoLandingPage(props) {
  return (
    <>
      <div className="no-data-landing-wrape">
        <div className="img-wrape">
          <img src={NoImg} alt="" />
        </div>
        <div className="detail new-design">
          <h2 className="head center">This Page Can’t Be Accessed</h2>
          <p>The page you're trying to access is currently unavailable.</p>
          <p>If you believe this is an error or need further assistance, please contact support.</p>
          <Link to="/" className="btn btn-primary"> Back to Home</Link>
        </div>
      </div>
      <ConsentManager data={""} />
    </>
  );
}

export default NoLandingPage;